module.exports = "/images/vendor/flag-icon-css/flags/4x3/eh.svg?3b662831ee7dd98f8995817929c38fe5";